import { catalog, getItem, type Quality } from '@wyn/content';
import { balance } from '../config/balance.ts';

/** The cheapest price each item is sold at by an NPC shop. */
const shopPrice = new Map<string, number>();
for (const shop of catalog.shops) for (const s of shop.stock) shopPrice.set(s.item, Math.min(s.price, shopPrice.get(s.item) ?? Infinity));

/**
 * What one of an item is worth in coin, for valuing yields and inventories. An item's `value` (what the
 * Market Cross will haggle over) when it has one, otherwise what a shop sells it for. Quality scales
 * both, as it does at the haggling table.
 *
 * This is deliberately not the item's `value`: giving shop goods a `value` would let the Market Cross
 * buy them back above the shop price, a coin faucet (docs/DECISIONS.md #113).
 */
export function itemWorth(itemKey: string, quality: Quality = balance.start.quality): number {
  const base = getItem(itemKey).value ?? shopPrice.get(itemKey) ?? 0;
  return base * balance.minigames.qualityValue[quality];
}
